export const cookies = {
  FarmersPlanToken: 'FarmersPlanToken',
  CropsSelectedAccount: 'selectedAccount',
  CropsRoleId: 'roleId',
  FarmIdCookie: 'farmIdCookie',
};

export const storageKeys = {
  RecentFarmId: 'recentFarmId',
  RecentFarmName: 'recentFarmName',
  RecentFarmOrgNumber: 'recentFarmOrgNumber',
  FarmOnboardingCelebrationPending: 'farmOnboardingCelebrationPending',
  FarmOnboardingCelebrationFarmId: 'farmOnboardingCelebrationFarmId',
  FarmOnboardingRegistrationDate: 'farmOnboardingRegistrationDate',
  FarmOnboardingRegistrationFarmId: 'farmOnboardingRegistrationFarmId',
  HideFarmOnboardingPrefix: 'hideFarmOnboarding:',
};
